import { render, staticRenderFns } from "./Git.vue?vue&type=template&id=f948c986&"
import script from "./Git.vue?vue&type=script&lang=js&"
export * from "./Git.vue?vue&type=script&lang=js&"
import style0 from "./Git.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports